import * as React from 'react';

import { SelectValue } from '@radix-ui/react-select';
import { ChevronDownIcon } from 'lucide-react';

import { useMediaQuery } from '../../hooks/use-media-query.jsx';
import { cn } from '../../utils/cn.js';

import { Button } from './button.jsx';
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from './command.jsx';
import { Drawer, DrawerContent, DrawerTrigger } from './drawer.jsx';
import { Select, SelectContent, SelectTrigger } from './select.jsx';

export function Combobox({
  value,
  items = [],
  labelKey,
  valueKey,
  status = {
    key: '',
    colors: {},
  },
  valueObject = null,
  onChange,
  onOpen,
  disabled = false,
  isLoading = false,
  isError = false,
  placeholder = '',
  className,
  variant = 'default',
}) {
  const [open, setOpen] = React.useState(false);
  const isDesktop = useMediaQuery('(min-width: 768px)');

  const variants = {
    default: {},
    title: {
      trigger: '!border-none !outline-none !ring-0 text-xl !pl-0 font-semibold',
      show_select: true,
    },
    portal: {
      trigger: 'border-portal-foreground h-[46px] rounded-full',
    },
  };

  if (isDesktop) {
    return (
      <Select
        value={value}
        open={open}
        disabled={disabled}
        onOpenChange={setOpen}
      >
        <SelectTrigger
          icon={!variants[variant]?.show_select}
          className={cn(variants[variant]?.trigger, className)}
        >
          <SelectValue className="!flex !w-full" placeholder={placeholder}>
            <div className="flex items-center">
              {status.key && valueObject && (
                <div
                  className={`mr-2 size-2 rounded-full ${status.colors[valueObject[status.key]] ? status.colors[valueObject[status.key]] : 'bg-zinc-300'}`}
                ></div>
              )}
              {value}
              {variants[variant]?.show_select && (
                <ChevronDownIcon className="ml-2 size-4" />
              )}
            </div>
          </SelectValue>
        </SelectTrigger>
        <SelectContent className="p-0" align="start">
          <Command>
            <CommandInput placeholder="Pesquisar..." />
            <CommandList>
              {isLoading ? (
                <CommandEmpty>A carregar</CommandEmpty>
              ) : isError ? (
                <CommandEmpty>Erro</CommandEmpty>
              ) : (
                <>
                  <CommandEmpty>Resultados não encontrados.</CommandEmpty>
                  <CommandGroup>
                    {items.map((item, i) => (
                      <CommandItem
                        key={i}
                        /* onChange={(ev) => console.log(ev)} */
                        onSelect={(_) => {
                          onChange(item);
                          setOpen(false);
                        }}
                      >
                        {status.key && (
                          <div
                            className={`mr-2 size-2 rounded-full ${status.colors[item[status.key]] ? status.colors[item[status.key]] : 'bg-zinc-300'}`}
                          ></div>
                        )}
                        {item[labelKey]}
                      </CommandItem>
                    ))}
                  </CommandGroup>
                </>
              )}
            </CommandList>
          </Command>
        </SelectContent>
      </Select>
    );
  }

  return (
    <Drawer open={open} onOpenChange={setOpen}>
      <DrawerTrigger asChild>
        <Button
          variant="outline"
          className={cn(
            variants[variant]?.trigger,
            className,
            'flex w-full justify-start',
          )}
        >
          {value ? (
            <div className="flex items-center">
              {status.key && valueObject && (
                <div
                  className={`mr-2 size-2 rounded-full ${status.colors[valueObject[status.key]] ? status.colors[valueObject[status.key]] : 'bg-zinc-300'}`}
                ></div>
              )}
              {value}
            </div>
          ) : null}
        </Button>
      </DrawerTrigger>
      <DrawerContent>
        <div className="mt-4 border-t">
          <Command>
            <CommandInput placeholder="Pesquisar..." />
            <CommandList>
              {isLoading ? (
                <CommandEmpty>A carregar</CommandEmpty>
              ) : isError ? (
                <CommandEmpty>Erro</CommandEmpty>
              ) : (
                <>
                  <CommandEmpty>Resultados não encontrados.</CommandEmpty>
                  <CommandGroup>
                    {items.map((item, i) => (
                      <CommandItem
                        key={i}
                        onSelect={(_) => {
                          onChange(item);
                          setOpen(false);
                        }}
                      >
                        {status.key && (
                          <div
                            className={`mr-2 size-2 rounded-full ${status.colors[item[status.key]] ? status.colors[item[status.key]] : 'bg-zinc-300'}`}
                          ></div>
                        )}
                        {item[labelKey]}
                      </CommandItem>
                    ))}
                  </CommandGroup>
                </>
              )}
            </CommandList>
          </Command>
        </div>
      </DrawerContent>
    </Drawer>
  );
}
